import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        cart: localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [],
        allProducts: [],
        orderList: [],
        orders: [],
    },
    getters: {
        cartItemCount: (state) => {
            return state.cart.length;
        },
        cartTotalPrice: (state) => {
            let total = 0;

            state.cart.forEach(item => {
                total += item.product.price * item.quantity
            })

            return total;
        },
        getOrders: (state) => {
            return state.orders;
        },
        getOrderDetails: (state) => (orderNo) => {
            return state.orders.find(order => order.id === orderNo
            )
        }
    },
    mutations: {
        ADD_TO_CART: (state, {product, quantity}) => {
            let productInCart = state.cart.find(item => {
                return item.product.id === product.id;
            });

            if (productInCart) {
                productInCart.quantity += quantity;
            } else {

                state.cart.push({
                    product,
                    quantity
                });
            }
        },
        UPDATE_QUANTITY: (state, {id, quantity}) => {
            let productInCart = state.cart.find(item => {
                return item.product.id === id;
            });

            if (productInCart) {
                productInCart.quantity = quantity;
            }
        },
        REMOVE_PRODUCT_FROM_CART: (state, {product}) => {
            state.cart = state.cart.filter(item => {
                return item.product.id !== product.id;
            });
        },
        EMPTY_CART: (state) => {
            state.cart = [];
        },
        RETRIEVED_ORDERS: (state, orders) => {
            state.orders = orders;
        },
        SAVE_DATA: (state) => {
            window.localStorage.setItem('cart', JSON.stringify(state.cart));
        }
    },

    actions: {
        retrieve_orders_customer: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/shopLocal/order')
                    .then((response) => {
                        commit('RETRIEVED_ORDERS', response.data);
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    })
            })
        },
        retrieve_orders_admin: ({commit}) => {
            return new Promise((resolve, reject) => {
                axios.get('/admin/shopLocal/order')
                    .then((response) => {
                        commit('RETRIEVED_ORDERS', response.data);
                        resolve(response.data)
                    })
                    .catch((error) => {
                        reject(error.response.data);
                    })
            })
        },
        addProductToCart: ({commit}, {product, quantity}) => {
            try {
                commit('ADD_TO_CART', {product, quantity});
                commit('SAVE_DATA');
            } catch (e) {
                throw new Error(e);
            }
        },
        updateQuantity: ({commit}, {id, quantity}) => {
            try {
                commit('UPDATE_QUANTITY', {id, quantity});
                commit('SAVE_DATA');
            } catch (e) {
                throw new Error(e);
            }
        },
        removeProductFromCart: ({commit}, {product}) => {
            try {
                commit('REMOVE_PRODUCT_FROM_CART', {product});
                commit('SAVE_DATA');
            } catch (e) {
                throw new Error(e);
            }
        },
        emptyCart: ({commit}) => {
            try {
                commit('EMPTY_CART');
                commit('SAVE_DATA');
            } catch (e) {
                throw new Error(e);
            }
        }
    }
})
